import { ImageFit, ImageFormat, ImagePosition } from "./interface/ImageData";
import type { ImageUrlParams } from "design-system/src/Components/Image/interface/ImageData";
import { IMAGE_CDN_BASE_URL } from "@src/utils/constants";

/** CloudFront URL — même formule que `useSushiShopImage` pour usage hors composant React. */
const cdnBaseUrl = IMAGE_CDN_BASE_URL;

const AUTO = "auto";

export function generateSushiShopImageUrl({
  id,
  width = AUTO,
  height = AUTO,
  fit = ImageFit.COVER,
  position = ImagePosition.CENTER,
  format = ImageFormat.AUTO,
  quality = AUTO,
  rewrite = "",
  extension = "",
}: ImageUrlParams): string {
  const id_picture = +id > 0 ? id : "0";
  const { round } = Math;
  const filename = rewrite || +id > 0 ? id : "default";
  const h = height === AUTO ? "auto" : round(height || 0).toFixed(0);
  const w = width === AUTO ? "auto" : round(width || 0).toFixed(0);
  const ext =
    extension || format === ImageFormat.PNG
      ? ImageFormat.PNG
      : format !== "auto"
      ? format
      : ImageFormat.JPG;

  return `${cdnBaseUrl}/img2/${id_picture}/${w}/${h}/${fit}/${position}/${format}/${quality}/${filename}.${ext}`;
}
